import { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_VideoResponse } from '../../../api'

interface VideoProps {
  id: number
  videoURL: string | undefined
  videoHeight: number | undefined
  videoWidth: number | undefined
  callback: (response: SurveyEngine_Models_BaseResponse) => void
  focus: boolean
}

export const VideoCommand = (props: VideoProps) => {
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    let response: SurveyEngine_Models_VideoResponse = {
      commandType: "Video",
      commandIndex: props.id,
    };
    props.callback(response);
  }, [props])
  const onReady = () => {
    if (props.focus) {
      (document.getElementsByTagName('iframe')[0] as HTMLIFrameElement).contentWindow?.focus();
    }
  }
  const handleError = () => {
      setIsError(true);
  }
  return (
    <div className="theme-video w-full">
      {isError ? (
        <embed src={props.videoURL} className='theme-video-player' height='100%' width='100%'></embed>
      ) : 
      <ReactPlayer
        className='theme-video-player'
        url={props.videoURL}
        //width={props.videoWidth}
        //height={props.videoHeight}
        width='100%'
        height='100%'
        onReady={onReady}
        data-testid={'test'+props.id}
        onError = {handleError}
        // onEnded={}
      />
    }
    </div>
  )
}